// Date/time formatters used across the widget.
//
// Caveat — middleware TZ behavior:
// The middleware's stub adapter currently treats store-local HH:mm strings as
// UTC (per the Phase 1A production gaps memo, item 4). So a slot at
// "2026-05-27T10:00:00.000Z" was MEANT to be 10:00 AM in the store's local
// timezone, not 10:00 UTC.
//
// Until the middleware adopts proper TZ math, the widget displays the HH:MM
// components from the ISO string AS-IS without any timezone conversion. This
// gives the correct user-facing time in every store regardless of browser TZ.
//
// When the middleware fix lands, switch these helpers to:
//   new Intl.DateTimeFormat('en-US', { timeZone: storeTimezone, ... }).format(date)

export function formatSlotTime(iso: string): string {
  // Expect "YYYY-MM-DDTHH:mm:ss(.SSS)?Z?" — pull HH:mm out directly
  const m = /T(\d{2}):(\d{2})/.exec(iso);
  if (!m) return iso;
  const hour24 = parseInt(m[1], 10);
  const minute = m[2];
  const ampm = hour24 >= 12 ? 'PM' : 'AM';
  const hour = hour24 % 12 || 12;
  return `${hour}:${minute} ${ampm}`;
}

export function formatPillDate(date: string): string {
  // YYYY-MM-DD → "Wed May 20th"
  const d = new Date(date + 'T00:00:00');
  const day = d.toLocaleDateString('en-US', { weekday: 'short' });
  const month = d.toLocaleDateString('en-US', { month: 'short' });
  const dayNum = d.getDate();
  const suffix = (n: number) => {
    if (n % 10 === 1 && n !== 11) return 'st';
    if (n % 10 === 2 && n !== 12) return 'nd';
    if (n % 10 === 3 && n !== 13) return 'rd';
    return 'th';
  };
  return `${day} ${month} ${dayNum}${suffix(dayNum)}`;
}
